import { Component, Inject, ViewContainerRef, TemplateRef } from '@angular/core';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ProfileService } from '../../services/profile/profile.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-media-library-list',
    templateUrl: './media-library-list.component.html',
    styleUrls: ['./media-library-list.component.css']
})
/** media-library-list component*/
export class MediaLibraryListComponent {
    /** media-library-list ctor */
  public mediaList: MediaLibrary[];
  public imageDetail = new MediaLibrary();
  FolderItems: any[];
  groupByName : string[] = [];
  i: number;
  uploadBy: number;
  folderName: any[];
  folderImages: MediaLibrary[];
  visibleImages: boolean;
  visibleFolder: boolean;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  constructor(private readonly profileService: ProfileService, private readonly mediaService: MediaLibraryService,
    private readonly utilitiesService: UtilitiesService, private modalService: BsModalService, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("medialibrary").subscribe(
      data => {
        if (data != null) {
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          if (list.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.GetMediaLibraryList();
            this.visibleImages = true;
            this.visibleFolder = false;
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  BacktoFolder() {
    this.visibleImages = true;
    this.visibleFolder = false;
  }
  GetImage(mediaName) {
    
    this.visibleImages = false;
    this.visibleFolder = true;
    this.folderImages = this.mediaList;
    //  this.folderImages = this.utilitiesService.GetSearchedResult(this.folderImages, mediaName);
    this.folderImages = this.folderImages.filter(s => s.imageFor == mediaName);
  }
  onSubmit() {
    this.mediaService.updateMediaLibrary(this.imageDetail).subscribe(
      result => {
        if (result) {
          this.modalRef.hide();
          this.toastr.success('Media Image Info has been Updated. ', 'Success');
        }
        else {
          this.toastr.error('Error occurred. Oop!', 'Error');
        }
      }
    )
  }
  openModal(template: TemplateRef<any>, id) {
    this.mediaService.getMediaLibraryById(id).subscribe(
      data => {
        if (data) {
          this.imageDetail = data;
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }
      }
    )
  }
  
  GetMediaLibraryList() {
    this.mediaService.getMediaLibrary().subscribe(
      data => {
        this.mediaList = data;
        this.folderImages = data;
        this.folderName = [];
        //this.groupByName = media
        for (let media of this.mediaList) {
          
          if (!this.groupByName.some((item) => item == media.imageFor)) {
            this.groupByName.push(media.imageFor);
          }
         // groupByName[media.imageFor] = groupByName[media.imageFor] || [media];
          //this.folderBlog.push(groupByName[media.imageFor]);
          //this.folderName = this.groupByName;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mediaLibrary-components/media-library-list/media-library-list.component.ts